<template>
    <aside>
        <header class="mb-3 d-flex">
            <search-input v-model="search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'addresses.create' }"
                :title="$t('Create new address')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new address')"/>
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="address in items"
                    :key="address.id"
                    :to="{ name: 'addresses.show', params: { id: address.id } }"
                    class="flex-column align-items-start mb-1"
                    tag="li"
                >
                    <article>
                        <h2 class="h5 mb-1">
                            <template v-if="address.label">{{ address.label }}<br></template>
                            <template v-if="address.first_name">{{ address.first_name }} {{ address.last_name }}</template>
                            <small class="d-block" v-if="address.organization">{{ address.organization}}</small>
                        </h2>

                        <address class="small mt-3 mb-0">
                            <template v-if="address.street">{{ address.street }}<br></template>
                            <template v-if="address.postal_code || address.city">{{ address.postal_code }} {{ address.city }}<br></template>
                            <template v-if="address.country_code">{{ address.country_code }}</template>
                        </address>
                    </article>
                </b-list-group-item>
            </b-list-group>
        </nav>

        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>

        <no-results-found v-if="!pending && !items.length"/>
    </aside>
</template>
<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import NoResultsFound from "@/components/NoResultsFound";
    import crudListener from "@/mixins/crudListener";
    import SearchInput from "@/components/SeachInput";

    export default {
        name: 'Addresses',
        components: {SearchInput, NoResultsFound},
        mixins: [fetchPaginatedData, crudListener],
        computed: {
            apiUrl() {
                return '/api/addresses'
            },
            resourceName() {
                return 'addresses';
            }
        },
    }
</script>
